import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { I18n } from 'common'
import { SpecificationRow } from './SpecificationRow'
import {
  StyledItemsTitle,
  CartTable,
  HeaderRow,
  ColHeader,
  Hr,
  StyledItemsLaborSpecsTitleWrapper,
} from '../SytledTable'
import { Vehicle } from '../../../../store/models/Vehicles'
import { useSelector } from 'react-redux'
import { RootState, store } from 'store'
import { getVehicleSpecifications } from 'cart'
import { cartSlice } from 'cart'
import { toJS } from 'mobx'

interface CartSpecificationItemsInterface {
  currentVehicle: Vehicle
}
export const CartSpecificationItems = observer(
  (props: CartSpecificationItemsInterface): ReactElement | null => {
    const { currentVehicle } = props

    const specifications = useSelector((state: RootState) =>
      getVehicleSpecifications(state, currentVehicle)
    )

    const removeSpecification = (hash: string): void => {
      const filteredSpecification = specifications?.filter(
        (specification) => specification.hash !== hash
      )
      store.dispatch(
        cartSlice.actions.setVehicleSpecifications({
          vehicle: toJS(currentVehicle),
          specifications: toJS(filteredSpecification),
        })
      )
    }

    if (specifications?.length <= 0) {
      return null
    }

    return (
      <>
        <StyledItemsLaborSpecsTitleWrapper>
          <StyledItemsTitle>
            <I18n name="specifications" />
          </StyledItemsTitle>
        </StyledItemsLaborSpecsTitleWrapper>
        <CartTable>
          <HeaderRow>
            <tr>
              <ColHeader>
                <I18n name="description" />
              </ColHeader>
            </tr>
          </HeaderRow>
          <tbody>
            {specifications?.map((specification) => (
              <>
                <SpecificationRow
                  key={specification.hash}
                  specification={specification}
                  removeSpecification={removeSpecification}
                />
                <Hr />
              </>
            ))}
          </tbody>
        </CartTable>
      </>
    )
  }
)
